import { AccessGuids, AlertClassColour, ApplicationNames, ConfigSystemParamDefaults, ConfigSystemParams, CostCentreAutoLevels, FieldAliases, modalFormValues, msSize, OurColors, OurCompany, SystemLocks, TypeAccess, TypeOccupation } from 'src/app/core/consts';
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, debounceTime, Observable, Subscription, throwError } from 'rxjs';
import { CliUpdatesDTO, InviewUserDTO } from 'src/app/core/models/inview/inview-user.dto';
import { CommunicationComposeModalFormComponent } from '../../_communication/communication-compose-modal-form/communication-compose-modal-form.component';
import { CommunicationModalFormComponent } from '../../_communication/communication-modal-form/communication-modal-form.component';
import { CompaniesService } from 'src/app/core/services/utelize/system/company/companies-service';
import { CompanyDTO } from 'src/app/core/models/system/company/company.dto';
import { CompanyModalFormComponent } from '../../_company/company-modal-form/company-modal-form.component';
import { CompletedModalFormComponent } from '../../_pop-ups/completed-modal-form/completed-modal-form.component';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ConfirmationModalFormComponent } from '../../_pop-ups/confirmation-modal-form/confirmation-modal-form.component';
import { CountriesService } from 'src/app/core/services/utelize/system/mapping/countries-service';
import { DatePipe } from '@angular/common';
import { DecryptAesClientSide } from 'src/app/core/encryption';
import { DropdownCountryDiallingCodeComponent } from 'src/app/core/dropdowns/country-dialling-code/dropdown-country-dialling-code.component';
import { eUser } from 'src/app/core/enums';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { getUtcTimestamp } from 'src/app/core/functions-generic/functions-generic-date';
import { Guid } from 'guid-typescript';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { InviewCompaniesService } from 'src/app/core/services/utelize/inview/inview-companies-service';
import { InviewCostCentreDTO } from 'src/app/core/models/inview/inview-cost-centre.dto';
import { InviewCostCentresService } from 'src/app/core/services/utelize/inview/inview-cost-centres-service';
import { InviewUsersClisService } from 'src/app/core/services/utelize/inview/inview-users-clis-service';
import { InviewUsersService } from 'src/app/core/services/utelize/inview/inview-users-service';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { NgbModal, NgbModalRef, NgbNav, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { SystemLockDTO } from 'src/app/core/models/system/system-lock/system-lock.dto';
import { SystemLockService } from 'src/app/core/services/utelize/system/system-lock/system-lock-service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TotpService } from 'src/app/core/services/utelize/general/totp-service';
import { TypesAccessService } from 'src/app/core/services/utelize/system/type/types-access-service';
import { TypesOccupationService } from 'src/app/core/services/utelize/system/type/types-occupation-service';
import { UserDTO } from 'src/app/core/models/system/user/user.dto';
import { UserGroupModalEditFormComponent } from 'src/app/forms-modal/user-groups-modal-edit-form/user-groups-modal-edit-form.component';
import { UserGroupsEmbeddedComponent } from 'src/app/pages-embedded/user-groups/user-groups.component';
import { UserGroupService } from 'src/app/core/services/utelize/system/user-group/user-group-service';
import { UserModalFormSearchComponent } from '../../_user/user-modal-form-search/user-modal-form-search.component';
import { UsersService } from 'src/app/core/services/utelize/system/user/users-service';
import { ValidatorService } from 'src/app/core/services/utelize/general/validator-service';
import { WarningModalFormComponent } from '../../_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-user-modal-form',
  templateUrl: './user-modal-form.component.html',
  styleUrls: ['./user-modal-form.component.scss']
})

export class UserModalFormComponent implements AfterViewInit, OnDestroy, OnInit {

  @Input() disableCompanyModal   : boolean | undefined;
  @Input() forceCreateNewUser    : boolean | undefined;
  @Input() initialInviewCompanyId: number  | undefined;
  @Input() inputInviewUserId     : number  | undefined;
  @Input() lockCompanyDropDown   : boolean | undefined;
  
  @Output() inviewUserDataHasBeenSaved : EventEmitter<any>  = new EventEmitter<any>();
  @Output() sureSimUserDataHasBeenSaved: EventEmitter<any>  = new EventEmitter<any>();
  @Output() userFormCancelled          : EventEmitter<void> = new EventEmitter<void>();
  
  @ViewChild('ArrowNgbNav'                                     ) arrowNav!                     : NgbNav;
  @ViewChild('communicationComposeModalForm', { static: false }) communicationComposeModalForm!: CommunicationComposeModalFormComponent;
  @ViewChild('communicationModalForm',        { static: false }) communicationModalForm!       : CommunicationModalFormComponent;
  @ViewChild('companyModalForm',              { static: false }) companyModalForm!             : CompanyModalFormComponent;
  @ViewChild('completedModalForm',            { static: false }) completedModalForm!           : CompletedModalFormComponent;
  @ViewChild('dialCodeDropdown'                                ) dialCodeDropdown!             : DropdownCountryDiallingCodeComponent;
  @ViewChild('reset2FaConfirmModal',          { static: false }) reset2FaConfirmModal!         : ConfirmationModalFormComponent;
  @ViewChild('resetPasswordConfirmModal',     { static: false }) resetPasswordConfirmModal!    : ConfirmationModalFormComponent;
  @ViewChild('userGroupModalForm',            { static: false }) userGroupModalForm!           : UserGroupModalEditFormComponent;
  @ViewChild('userGroupConfirmModal',         { static: false }) userGroupConfirmModal!        : ConfirmationModalFormComponent;
  @ViewChild('userGroups',                    { static: false }) userGroups!                   : UserGroupsEmbeddedComponent;
  @ViewChild('userModalForm',                 { static: false }) userModalForm!                : TemplateRef<void>;
  @ViewChild('userSearchForm',                { static: false }) userSearchForm!               : UserModalFormSearchComponent;
  @ViewChild('warningModalForm',              { static: false }) warningModalForm!             : WarningModalFormComponent;

  get canSelectSuperUserRole() { return this.componentAccessUserService.hasAccessGuid(AccessGuids.FormUserAccessTypeSuperUserSelectionAllow, true); }
  
  get fieldAliasTag  () { return this.configSystemService.getValue(ConfigSystemParams.FieldAliasTag,  FieldAliases.FieldAliasTag  ); }
  get fieldAliasTag2 () { return this.configSystemService.getValue(ConfigSystemParams.FieldAliasTag2, FieldAliases.FieldAliasTag2 ); }
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false)     ; }

  get autofill                       () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserAutofill,                        false); }
  get showSupport                    () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowSupport,                             true ); }
  get showUserGroups                 () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowUserGroups,                          true ); }
  get showUsernameAndMobileWhenDevice() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserShowUsernameAndMobileWhenDevice, false)&&
                                                 this.componentAccessUserService.hasAccessGuid(AccessGuids.FormUserShowUsernameAndMobileWhenDevice           ); }
  get showUserRole                   () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserShowUserRole,                    false); }
  get submitEnableOnEdit             () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserSubmitEnableOnEdit,              true ); }
  get systemLocksEnabled             () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SystemLocksEnabled,                      true ); }
  get systemLocksShowDetails         () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SystemLocksShowDetails,                  true ); }
  get systemLocksShowWarningModal    () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SystemLocksShowWarningModal,             true ); }
  
  private accessTypeIdData!           : IdAndDescriptionDTO[];
  private communicationModalFormIsOpen: boolean=false;
  private countryIdData!              : IdAndDescriptionDTO[];
  private costCentreModalRef!         : NgbModalRef;
  private existingToBePortalUser      : boolean=false;
  private formChangesSubscription?    : Subscription;
  private initialInviewCompanyIdSet   : boolean=false;
  private initialStatus               : string="Please complete the following details";
  private inviewCompanyIdData!        : IdAndDescriptionDTO[];
  private inviewCostCentreIdLv1Data!  : IdAndDescriptionDTO[];
  private inviewCostCentreIdLv2Data!  : IdAndDescriptionDTO[];
  private inviewCostCentreIdLv1Auto   : number=0;
  private inviewCostCentreIdLv2Auto   : number=0;
  private inviewUserCreated           : boolean=false;
  private inviewUserIdData!           : InviewUserDTO[];
  private occupationTypeIdData!       : IdAndDescriptionDTO[];
  private originalMobileNo            : string | undefined;
  private selectedInviewCompany?      : IdAndDescriptionDTO;
  private selectedInviewCostCentreLv1?: IdAndDescriptionDTO;
  private selectedInviewCostCentreLv2?: IdAndDescriptionDTO;
  private selectedInviewUser?         : InviewUserDTO;
  private sureSimCompanyId            : number | undefined;
  private systemLockId                : number | undefined;
  private userModalFormRef!           : NgbModalRef;
  private userToBePortalAndEsimUser   : boolean=false;
  private userType                    : eUser=eUser.unknown;

  public activeId                     : number=1;
  public addInviewCompanyButtonText   : string="";
  public alertColourOrderStatus       : string=AlertClassColour.Grey;
  public alertColourProgress          : string=AlertClassColour.Grey;
  public allocationID                 : number = 0;
  public associateUser                : boolean=false;
  public closeFormOnCompleted         : boolean=true;
  public costCentreAddFormSubmitted   : boolean=false;
  public costCentreAddForm!           : UntypedFormGroup;
  public costCentreLv1ButtonEnabled   : boolean=false;
  public costCentreLevel              : number=0;
  public costCentreMissingInInview    : boolean=false;
  public createNewCompany             : boolean=false;
  public createNewUserSelected        : boolean=false;
  public curUser                      : SystemUserDTO;
  public fileLockHoverText            : string | undefined;
  public formIsLocked                 : boolean=false;
  public formTitle                    : string="User";
  // public haveInviewUserData           : boolean=false;
  public inviewAccountLocked          : boolean=false;
  public inviewAutoCreateCostCentres  : boolean=false;
  public inviewCompanySelected        : boolean=false;
  public inviewUserSelected           : boolean=false;
  public isRequired                   = (path: string) => this.validatorService.isRequired(this.userForm, path, this.newUser);
  public isIotDevice                  : boolean | undefined;
  public newUser                      : boolean=false;
  // public partialUserSearchEnabled     : boolean=false;
  public portalUser                   : boolean=false;
  public progressInformation          : string=this.initialStatus;
  public registerCompany              : boolean=false;
  public searchForInviewUser          : boolean=false;
  public selectedInviewCompanyId      : number=0;
  public showActive                   : boolean=false;
  public showBillRecipient            : boolean=false;
  public showComposeForm              : boolean=false;
  public showCostCentres              : boolean=false;
  public showMessageIcon              : boolean=false;
  public showOccupation               : boolean=false;
  public submitButtonEnabled          : boolean=false;
  public sureSimCompany               : CompanyDTO | undefined;
  public sureSimUser                  : UserDTO | undefined;
  public sureSimUserId                : number | undefined;
  public systemAdmin                  : boolean=false;
  public useInternationalDialCode     : boolean=false;
  public userForm!                    : UntypedFormGroup;
  public userFormSubmitted            : boolean=false;
  public warningMessageMain           : string | undefined;
  public warningMessageSub            : string | undefined;

  //#region NavItems

  public navItemBasicDetails          : number=1;
  public navItemGroups                : number=2;
  public navItemSupport               : number=3;

  //#endregion

  //#region for Validators
  
  public customerTagMaxLength         : number=50;
  public customerTag2MaxLength        : number=50;
  public emailMaxLength               : number=100;
  public firstnameMaxLength           : number=100;
  public lastnameMaxLength            : number=100;
  public mobilenumberMaxLength        : number=100;
  public usernameMaxLength            : number=100;
  
  //#endregion  

  constructor(
    private authenticationService     : AuthenticationService,
    private changeDetectorRef         : ChangeDetectorRef,
    private companiesService          : CompaniesService,
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private countriesService          : CountriesService,
    private datePipe                  : DatePipe,
    private exceptionsService         : ExceptionsService,
    private formBuilder               : UntypedFormBuilder,
    private inviewCompaniesService    : InviewCompaniesService,
    private inviewCostCentresService  : InviewCostCentresService,
    private inviewUsersClisService    : InviewUsersClisService,
    private inviewUsersService        : InviewUsersService,
    private lastPassKillerService     : LastPassKillerService,
    private modalService              : NgbModal,
    private systemLockService         : SystemLockService,
    private totpService               : TotpService,
    private typesAccessService        : TypesAccessService,
    private typesOccupationService    : TypesOccupationService,
    private userGroupService          : UserGroupService,
    private usersService              : UsersService,
    private validatorService          : ValidatorService
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      //CRN_20251215 - User modal content in ng-template, so not in DOM
      //this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
      
      if (this.formChangesSubscription) {
        this.formChangesSubscription.unsubscribe();
        this.formChangesSubscription=undefined;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public resetMainVariables(): void {
    try {
      this.activeId                    = 1;
      this.addInviewCompanyButtonText  ="Add";
      this.alertColourProgress         =AlertClassColour.Grey;
      this.createNewCompany            =false;
      this.createNewUserSelected       =false;
      this.communicationModalFormIsOpen=false;
      this.costCentreAddFormSubmitted  =false;
      this.costCentreMissingInInview   =false;
      this.existingToBePortalUser      =false;
      // this.haveInviewUserData          =false;
      this.inviewAutoCreateCostCentres =this.configSystemService.getValueAsBoolean(ConfigSystemParams.InviewAutoCreateCostCentres, false);
      this.inviewCompanySelected       =false;
      this.inviewCostCentreIdLv1Auto   =0;
      this.inviewCostCentreIdLv2Auto   =0;
      this.inviewUserCreated           =false;
      this.inviewUserSelected          =false;
      // this.partialUserSearchEnabled    =false;
      this.progressInformation         =this.initialStatus;
      this.registerCompany             =false;
      this.searchForInviewUser         =false;
      this.selectedInviewCompanyId     =0;
      this.showActive                  = (this.userType==eUser.associate && this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserShowActiveAssociate       )) ||
                                         (this.userType==eUser.portal    && this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserShowActivePortal          )) ||
                                         (this.userType==eUser.sim       && this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserShowActiveEsim            ));
      this.showBillRecipient           = (this.userType==eUser.associate && this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserShowBillRecipientAssociate)) ||
                                         (this.userType==eUser.portal    && this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserShowBillRecipientPortal   )) ||
                                         (this.userType==eUser.sim       && this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserShowBillRecipientEsim     ));
      this.showComposeForm             =false;
      this.showCostCentres             =this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserShowCostCentres, true);
      this.showMessageIcon             = (this.userType==eUser.associate && this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserShowMessageIconAssociate  )) ||
                                         (this.userType==eUser.portal    && this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserShowMessageIconPortal     )) ||
                                         (this.userType==eUser.sim       && this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserShowMessageIconEsim       ));
      this.showOccupation              = (this.userType==eUser.associate && this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserShowOccupationAssociate   )) ||
                                         (this.userType==eUser.portal    && this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserShowOccupationPortal      )) ||
                                         (this.userType==eUser.sim       && this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserShowOccupationEsim        ));
      this.sureSimCompany              =undefined;
      this.sureSimUser                 =undefined;
      this.useInternationalDialCode    =this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserUseInternationalDialCode, false);
      this.userFormSubmitted           =false;
      this.userToBePortalAndEsimUser   =false;

      this.selectedInviewCompany       =undefined;
      this.selectedInviewCostCentreLv1 =undefined;
      this.selectedInviewCostCentreLv2 =undefined;
      this.selectedInviewUser          =undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openForm(sureSimUserId: number | undefined, userType: eUser): void {
    try {
      this.associateUser            =(userType==eUser.associate);
      this.fileLockHoverText        ="User is being edited by another";
      this.formIsLocked             =false;
      this.initialInviewCompanyIdSet=false;
      this.isIotDevice              =undefined;
      this.portalUser               =(userType==eUser.portal);
      this.systemLockId             =undefined;
      this.userType                 =userType;

      this.resetMainVariables();
      this.refreshInviewCompanyData();
      this.refreshAccessTypeData();
      this.refreshCountryData();
      this.refreshOccupationTypeData();
      this.setUpForm();
      
      if (sureSimUserId != undefined && <number>sureSimUserId>0) {
        this.newUser      =false;
        this.sureSimUserId=sureSimUserId;

        this.componentAccessUserService.hasAccessGuid(AccessGuids.FormUserChangeUserRole) ? this.userForm.controls["accessTypeId"].enable() : this.userForm.controls["accessTypeId"].disable();
        
        this.setFormTitle(false);
        this.enableDisableControls(!this.submitEnableOnEdit);
        this.updateSubmitButtonAppearance();
        this.processSystemLock();
        this.getSureSimUser();
      } else {
        this.newUser      =true;
        this.sureSimUserId=0;

        this.setFormTitle(true);
        this.enableDisableControls(false);
        this.applyDefaultAccessTypeId();
        this.openModal();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openModal(): void {
    try {
      this.userModalFormRef=this.modalService.open(this.userModalForm, { backdrop: this.modalBackGround, 
                                                                         centered: true,
                                                                         keyboard: false,
                                                                         size    : msSize.Large });

      //CRN_20251215 - DOM created, render... then lpKiller
      setTimeout(() => {
        this.lastPassKillerService.start();
        this.updateSubmitButtonAppearance();
      });                                                                
    }
    catch(e) {
      this.userFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setFormTitle(newUserEntry: boolean) {
    try {
      const titlePostFix: string=newUserEntry ? "Create" : "Manage";

      this.formTitle=titlePostFix + " " + (this.isIotDevice ? "IOT Device Subscription"
                                                            : (this.userType==eUser.portal ? "Portal User"
                                                                                           : (this.userType==eUser.sim ? "User"
                                                                                                                       : "Associate"
                                                                                             )
                                                              )
                                          );
    }
    catch(e) {
      this.userFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region userForm

  get formOfUserAdd() {
    return this.userForm.controls;
  }

  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.removeFormFields(this.costCentreAddForm);
      this.removeFormFields(this.userForm);

      this.costCentreAddForm=this.formBuilder.group({ });
      this.userForm         =this.formBuilder.group({ });
      
      this.addFormFields(this.costCentreAddForm);
      this.addFormFields(this.userForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.userForm) {
        let costCentreValidators: Validators=this.inviewAutoCreateCostCentres ? [] : [Validators.required];
        let sendBill            : boolean   =this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserSetSendBillOnAdd, false);

        this.addFormControl(formGroup, "accessTypeId",          "",        [Validators.required]);
        this.addFormControl(formGroup, "active",                true,      []);
        this.addFormControl(formGroup, "countryId",             "",        [Validators.required]);
        this.addFormControl(formGroup, "customerTag",           "",        [                     Validators.maxLength(this.customerTagMaxLength)]);
        this.addFormControl(formGroup, "customerTag2",          "",        [                     Validators.maxLength(this.customerTag2MaxLength)]);
        //this.addFormControl(formGroup, "email",                 "",        [Validators.required, Validators.maxLength(this.emailMaxLength), Validators.email]);
        this.addFormControl(formGroup, "hasSureSIMAccess",      false,     []);
        this.addFormControl(formGroup, "firstname",             "",        [Validators.required, Validators.maxLength(this.firstnameMaxLength)]);
        this.addFormControl(formGroup, "inviewCompanyId",       "",        [Validators.required]);
        this.addFormControl(formGroup, "inviewCostCentreIdLv1", "",        costCentreValidators);
        this.addFormControl(formGroup, "inviewCostCentreIdLv2", "",        costCentreValidators);
        this.addFormControl(formGroup, "inviewUserId",          "",        [Validators.required]);
        this.addFormControl(formGroup, "lastname",              "",        [Validators.required, Validators.maxLength(this.lastnameMaxLength)]);
        this.addFormControl(formGroup, "mobilenumber",          "",        [Validators.required, Validators.maxLength(this.mobilenumberMaxLength)]);
        this.addFormControl(formGroup, "mobilenumberE164",      "",        []);
        this.addFormControl(formGroup, "mobilenumberIntCode",   "",        []);
        this.addFormControl(formGroup, "occupationTypeId",      "",        [Validators.required]);
        // this.addFormControl(formGroup, "partialUserSearch",     "",        []);
        this.addFormControl(formGroup, "passwordEncTemp",       "",        []);
        this.addFormControl(formGroup, "sendBill",              sendBill,  []);
        this.addFormControl(formGroup, "useCostCentres",        false,     []);
        this.addFormControl(formGroup, "username",              "",        [Validators.required, Validators.email]);
        this.addFormControl(formGroup, "userOrIotDevice",       undefined, [Validators.required]);
        
        if (!this.portalUser) {
          this.userForm.get("accessTypeId")?.clearValidators();
          this.userForm.get("accessTypeId")?.updateValueAndValidity();
        }

      } else if (formGroup==this.costCentreAddForm) {
        this.addFormControl(formGroup, "costCentreName", "", [Validators.required]);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | number | string | undefined,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private populateFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.userForm && this.sureSimUser != undefined) {
        this.userForm.controls["active"].setValue(this.sureSimUser.active);
        this.userForm.controls["accessTypeId"].setValue(this.sureSimUser.accessTypeID);
        this.userForm.controls["countryId"].setValue(this.sureSimUser.countryID);
        this.userForm.controls["customerTag"].setValue(this.sureSimUser.tag);
        this.userForm.controls["customerTag2"].setValue(this.sureSimUser.tag2);
        //this.userForm.controls["email"].setValue(this.sureSimUser.email);
        this.userForm.controls["hasSureSIMAccess"].setValue(false); //(this.sureSimUser.hasSureSIMAccess);
        this.userForm.controls["firstname"].setValue(this.sureSimUser.firstname);
        this.userForm.controls["inviewCompanyId"].setValue(this.sureSimUser.inviewCompanyID);
        this.userForm.controls["inviewCostCentreIdLv1"].setValue(this.sureSimUser.inviewCostCentreID);
        this.userForm.controls["inviewCostCentreIdLv2"].setValue(this.sureSimUser.inviewCostCentreID2);
        this.userForm.controls["inviewUserId"].setValue(this.sureSimUser.inviewUserID);
        this.userForm.controls["lastname"].setValue(this.sureSimUser.lastname);
        this.userForm.controls["mobilenumber"].setValue(this.sureSimUser.mobile);
        this.userForm.controls["mobilenumberE164"].setValue(this.sureSimUser.mobileE164);
        this.userForm.controls["mobilenumberIntCode"].setValue(this.sureSimUser.mobileIntCode);
        this.userForm.controls["occupationTypeId"].setValue(this.sureSimUser.occupationTypeID);
        this.userForm.controls["passwordEncTemp"].setValue(DecryptAesClientSide(this.sureSimUser.passwordEncTemp ?? ""));
        this.userForm.controls["sendBill"].setValue(this.sureSimUser.sendBill);
        this.userForm.controls["username"].setValue(this.sureSimUser.username);
        this.userForm.controls["userOrIotDevice"].setValue(this.sureSimUser.iotDevice ? "iotDevice" : "user");

        this.isIotDevice=this.sureSimUser.iotDevice;

        this.setFormTitle(false);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private enableDisableControls(enabled: boolean) {
    try {
      this.submitButtonEnabled=enabled;
      
      this.updateSubmitButtonAppearance();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private updateSubmitButtonAppearance(): void {
    try {
      const btn=document.getElementById("add-btn");
      
      if (!btn)
        return;
  
      btn.classList.remove("btn-success","btn-danger");
      
      const shouldBeGreen=this.submitButtonEnabled || this.newUser;
      
      btn.classList.add(shouldBeGreen ? "btn-success" : "btn-danger");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public userOrIotDeviceRadiosVisible(): boolean {
    try {
      return !this.associateUser &&
             !this.portalUser &&
             this.createNewUserSelected &&
             this.isIotDevice==undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public userOrIotDeviceChange(type: string) {
    try {
      this.isIotDevice=type=="iotDevice";

      if (this.isIotDevice) {
        const timeStamp   : string | undefined=getUtcTimestamp(this.exceptionsService);
        const random3str  : string=String(Math.floor(Math.random() * 1000)).padStart(3, '0');
        const mobilenumber: string=timeStamp+random3str;
        
        this.userForm.controls["username"].setValue(`${mobilenumber}@${OurCompany.SureSimIoDomain}`);
        this.userForm.controls["mobilenumber"].setValue(mobilenumber);
      }

      this.setFormTitle(this.newUser);
      this.setOrClearCostCentreValidators(this.costCentreDropdownsVisible());
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public costCentreSectionAvailable(): boolean {
    try {
      return this.sureSimCompany != undefined &&
             this.sureSimCompany.pureSSCompany != undefined &&
             !this.sureSimCompany.pureSSCompany &&
             ((this.createNewUserSelected && this.isIotDevice != undefined) || this.inviewUserSelected);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public costCentreCheckBoxVisible(): boolean {
    try {
      return !this.showCostCentres && this.costCentreSectionAvailable();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public costCentreDropdownsVisible(): boolean {
    try {
      if (!this.costCentreSectionAvailable())
        return false;

      if (this.showCostCentres)
        return true;

      return this.userForm?.get("useCostCentres")?.value==true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public useCostCentresChange(): void {
    try {
      const useCostCentres: boolean=this.userForm.get("useCostCentres")?.value==true;

      if (!useCostCentres) {
        this.userForm.controls["inviewCostCentreIdLv1"].setValue("");
        this.userForm.controls["inviewCostCentreIdLv2"].setValue("");

        this.selectedInviewCostCentreLv1=undefined;
        this.selectedInviewCostCentreLv2=undefined;
        this.costCentreLv1ButtonEnabled =false;

      } else {
        this.refreshCostCentreLv2Data();
      }

      this.setOrClearCostCentreValidators(this.costCentreDropdownsVisible());
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Set or Clear Validators

  public setOrClearAccessTypeValidators(setValidators: boolean): void {
    try {
      if (setValidators)
        this.userForm.get("accessTypeId")?.setValidators([Validators.required]);
      else
        this.userForm.get("accessTypeId")?.clearValidators();

      this.userForm.get("accessTypeId")?.updateValueAndValidity();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setOrClearCostCentreValidators(setValidators: boolean): void {
    try {
      if (setValidators) {
        this.userForm.get("inviewCostCentreIdLv1")?.setValidators([Validators.required]);
        this.userForm.get("inviewCostCentreIdLv2")?.setValidators([Validators.required]);
      }
      else {
        this.userForm.get("inviewCostCentreIdLv1")?.clearValidators();
        this.userForm.get("inviewCostCentreIdLv2")?.clearValidators();
      }
      
      this.userForm.get("inviewCostCentreIdLv1")?.updateValueAndValidity();
      this.userForm.get("inviewCostCentreIdLv2")?.updateValueAndValidity();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setOrClearOccupationTypeValidators(setValidators: boolean): void {
    try {
      if (setValidators) {
        this.userForm.get("occupationTypeId")?.setValidators([Validators.required]);
      }
      else {
        this.userForm.get("occupationTypeId")?.clearValidators();
      }
      
      this.userForm.get("occupationTypeId")?.updateValueAndValidity();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setOrClearUserOrIotDeviceValidators(setValidators: boolean): void {
    try {
      if (setValidators) {
        this.userForm.get("userOrIotDevice")?.setValidators([Validators.required]);
      }
      else {
        this.userForm.get("userOrIotDevice")?.clearValidators();
      }
      
      this.userForm.get("userOrIotDevice")?.updateValueAndValidity();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
  
  public dialCodeChanged(): void {
    try {
      this.userForm.markAsDirty();

      if (!this.newUser && this.submitEnableOnEdit)
        this.enableDisableControls(this.userForm.dirty);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public userFormSubmitAttempt() {
    try {
      this.userFormSubmitted=true;

      this.setOrClearCostCentreValidators(this.costCentreDropdownsVisible());
      this.setOrClearOccupationTypeValidators(this.showOccupation && !(this.isIotDevice ?? false));
      this.setOrClearUserOrIotDeviceValidators(this.userOrIotDeviceRadiosVisible());
      this.setOrClearAccessTypeValidators(this.portalUser && this.showUserRole);

      if (this.useInternationalDialCode && this.isIotDevice != undefined && !this.isIotDevice) {
        this.dialCodeDropdown?.submit();

        if (this.dialCodeDropdown?.validData) {
          this.userForm.controls["mobilenumber"].setValue("0" + (this.dialCodeDropdown.outMobileNumber ?? ""));
          this.userForm.controls["mobilenumberE164"].setValue(this.dialCodeDropdown.outFullMobileNumber);
          this.userForm.controls["mobilenumberIntCode"].setValue(this.dialCodeDropdown.outIntDialCode);
        }
      }
      
      if (this.userForm.valid && (this.isIotDevice || !this.useInternationalDialCode || this.dialCodeDropdown?.validData)) {
          this.submitButtonEnabled=false;
          this.userFormSubmitCheckValues();
      }
    }
    catch(e) {
      this.submitButtonEnabled=true;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region userFromSubmitCheckValues
  
  public userFormSubmitCheckValues() {
    try {
      this.mobileNumberOK();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public mobileNumberOK() {
    try {
      let inviewUserId: number=(this.newUser ? this.selectedInviewUser?.userID : this.sureSimUser?.inviewUserID) ?? -1;
      
      this.inviewUsersClisService.cliExistsOnDifferentUser(inviewUserId, this.userForm.get('mobilenumber')?.value ?? "")
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          if (data.existsOnDifferentUser) {
            this.submitButtonEnabled=true;

            //CRN_20251001 - A user may be added from Inview where the Mobile Number field is disabled
            this.userForm.controls["mobilenumber"].enable();
            
            this.warningModalForm.openForm("Mobile number already exists",
                                           this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserShowFullCliInfoIfAllocated, false) ||
                                           this.curUser.systemAdmin ||
                                           this.curUser.systemAdminStd
                                           ?
                                           `The number ${this.userForm.get('mobilenumber')?.value} is assigned to:<br><br>` +
                                           `<strong>Company</strong> ${data.companyName}<br><br>` +
                                           `<strong>Username</strong> ${data.username}<br><br>` +
                                           `<strong>Email</strong> ${data.email}`
                                           :
                                           `The number ${this.userForm.get('mobilenumber')?.value} is assigned to another user`
                                          );

          } else {
            this.userFormSubmit();
          }
        },
        error: error => {
          this.submitButtonEnabled=true;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.submitButtonEnabled=true;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
  
  public userFormSubmit() {
    try {
      if (this.createNewUserSelected && !this.inviewUserCreated) {
        this.createInviewUser();
      } else {
        this.prepareToSaveUser();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public userFormCancel() {
    try {
      this.unlockEntity();

      this.lastPassKillerService.stop();
      this.userFormCancelled.emit();
      this.userModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Dropdown Arrays

  public getDropdownDataObjectArray(fieldName: string) {
    try {
      if (fieldName=="accessTypeId") {
        return this.accessTypeIdData;

      } else if (fieldName=="countryId") {
        return this.countryIdData;

      } else if (fieldName=="inviewCompanyId") {
        return this.inviewCompanyIdData;

      } else if (fieldName=="inviewCostCentreIdLv1") {
        return this.inviewCostCentreIdLv1Data;

      } else if (fieldName=="inviewCostCentreIdLv2") {
        return this.inviewCostCentreIdLv2Data;

      }else if (fieldName=="occupationTypeId") {
        return this.occupationTypeIdData;

      }

      return undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  public getDropdownDataObjectArray_InviewUser() {
    try {
      return this.inviewUserIdData;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  private getDropdownData(dataSource: Observable<any>, fieldName: string) {
    try {
      if (dataSource) {
        dataSource
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (fieldName=="accessTypeId") {
              this.accessTypeIdData=(data as IdAndDescriptionDTO[]);

              if (!this.canSelectSuperUserRole)
                this.accessTypeIdData=this.accessTypeIdData.filter(x => x.description !== TypeAccess.SuperUser);

              this.applyDefaultAccessTypeId();

            } else if (fieldName=="countryId") {
              this.countryIdData=(data as IdAndDescriptionDTO[]);

              if (this.newUser && (this.userForm.controls["countryId"].value==undefined || this.userForm.controls["countryId"].value=="")) {
                this.applyDefaultCountryId();
              }

            } else if (fieldName=="inviewCompanyId") {
              this.inviewCompanyIdData=(data as IdAndDescriptionDTO[]);

              if (!this.initialInviewCompanyIdSet && this.initialInviewCompanyId != undefined && this.initialInviewCompanyId>0) {
                this.userForm.controls["inviewCompanyId"].setValue(this.initialInviewCompanyId);
                
                this.initialInviewCompanyIdSet=true;
              }
              
              this.inviewCompanySelectDropDownChange(undefined);

            } else if (fieldName=="inviewCostCentreIdLv1") {
              let fireOnChange=this.userForm.get('inviewCostCentreIdLv1')?.value != undefined && <number>this.userForm.get('inviewCostCentreIdLv1')?.value>0;

              this.inviewCostCentreIdLv1Data=(data as IdAndDescriptionDTO[]);

              if (fireOnChange)
                this.costCentreLv1SelectDropDownChange(undefined);

            } else if (fieldName=="inviewCostCentreIdLv2") {
              let refreshCostCentreLv1Data=this.inviewCostCentreIdLv2Data.length==0;

              this.inviewCostCentreIdLv2Data=(data as IdAndDescriptionDTO[]);

              if (refreshCostCentreLv1Data)
                this.costCentreLv2SelectDropDownChange(undefined);
              
            } else if (fieldName=="inviewUserId") {
              this.inviewUserIdData=(data as InviewUserDTO[]);
              this.inviewUserIdData.unshift({ clIs                  : [],
                                              companyId             : 0,
                                              costCenterID          : 0,
                                              email                 : modalFormValues.createNewUser,
                                              existingToBePortalUser: false,
                                              firstName             : "",
                                              portalUser            : this.portalUser,
                                              surname               : "",
                                              userID                : modalFormValues.createNewUserId,
                                              username              : ""
                                            });

              let _inviewUserId=(this.inviewUserIdData.length==1 || this.forceCreateNewUser) ? <number>modalFormValues.createNewUserId : this.inputInviewUserId;
              
              if ((this.inviewUserIdData.length==1 || this.forceCreateNewUser) ||
                  (this.inputInviewUserId != undefined && (<number>this.inputInviewUserId>0  ||
                                                          (<number>this.inputInviewUserId==modalFormValues.createNewUserId))
                  )
                 ) {
                this.userForm.controls["inviewUserId"].setValue(_inviewUserId);
                this.userForm.controls["inviewUserId"].disable();
                this.inviewUserSelectDropDownChange(undefined);
              }
            } else if (fieldName=="occupationTypeId") {
              this.occupationTypeIdData=(data as IdAndDescriptionDTO[]);

              this.applyDefaultOccupationTypeId();
            }
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getInviewUserLabel(inviewUser: InviewUserDTO): string {
    try {
      return inviewUser.iotDevice ? (inviewUser.firstName ?? "") + " - " + (inviewUser.surname ?? "") : inviewUser.email;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return inviewUser?.email ?? "";
    }
  }

  //#endregion

  //#region Refresh Dropdown Arrays Data

  public refreshAccessTypeData() {
    try {
      this.getDropdownData(this.typesAccessService.getIdAndDescription(), "accessTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshCountryData() {
    try {
      this.getDropdownData(this.countriesService.getIdAndDescription(), "countryId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyDefaultAccessTypeId(): void {
    try {
      if (!this.portalUser || !this.newUser)
        return;

      const current=this.userForm.controls["accessTypeId"].value;

      if (current != undefined && current != '')
        return;

      const defaultEntry: IdAndDescriptionDTO|undefined=this.accessTypeIdData?.find(x => x.description==TypeAccess.Administrator);

      if (defaultEntry != undefined)
        this.userForm.controls["accessTypeId"].setValue(defaultEntry.id);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyDefaultCountryId(): void {
    try {
      if (this.sureSimCompany?.countryID != undefined && <number>this.sureSimCompany.countryID>0) {
        this.userForm.controls["countryId"].setValue(this.sureSimCompany.countryID);
        return;
      }

      const defaultName : string                       =this.configSystemService.getValue(ConfigSystemParams.CountriesDefault);
      const defaultEntry: IdAndDescriptionDTO|undefined=this.countryIdData?.find(x => x.description==defaultName);

      if (defaultEntry?.id != undefined) {
        this.userForm.controls["countryId"].setValue(defaultEntry.id);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyDefaultCountryIdLoadCompanyIfNeeded(): void {
    try {
      //RBW_20260529 - Edit flow: if the user has no country set, apply the company/system default (loading the company if not already cached)
      const currentValue: any=this.userForm.controls["countryId"].value;

      if (currentValue != undefined && currentValue != "" && <number>currentValue>0)
        return;

      if (this.sureSimCompany != undefined) {
        this.applyDefaultCountryId();
        return;
      }

      const companyId: number | undefined=this.sureSimUser?.companyID;

      if (companyId == undefined || companyId <= 0) {
        this.applyDefaultCountryId();
        return;
      }

      this.companiesService.getById(companyId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.sureSimCompany=data;
          this.applyDefaultCountryId();
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyDefaultOccupationTypeId(): void {
    try {
      if (!this.newUser)
        return;

      const current=this.userForm.controls["occupationTypeId"].value;

      if (current != undefined && current != '')
        return;

      const defaultEntry: IdAndDescriptionDTO|undefined=this.occupationTypeIdData?.find(x => x.description==TypeOccupation.NotKnown);

      if (defaultEntry != undefined)
        this.userForm.controls["occupationTypeId"].setValue(defaultEntry.id);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshOccupationTypeData() {
    try {
      this.getDropdownData(this.typesOccupationService.getIdAndDescription(), "occupationTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion

  //#region Inview Company

  public refreshInviewCompanyData() {
    try {
      this.getDropdownData(this.inviewCompaniesService.getIdAndDescription(this.curUser.inviewUserId), "inviewCompanyId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public inviewCompanySelectDropDownChange(ev: any) {
    try {
      if (!this.newUser)
        return;

      this.resetMainVariables();
      this.userForm.controls["inviewUserId"].setValue("");
      this.userForm.controls["inviewUserId"].enable();

      if (this.inviewCompanyIdData==undefined)
        return;

      this.enableDisableControls(false);

      this.selectedInviewCompany=this.inviewCompanyIdData.find(x => x.id==this.userForm.get('inviewCompanyId')?.value);
      let gotCompany            =this.selectedInviewCompany?.id!=undefined && <number>this.selectedInviewCompany?.id>0;      

      if (gotCompany) {
        this.selectedInviewCompanyId=<number>this.selectedInviewCompany?.id;

        if (this.lockCompanyDropDown) {
          this.userForm.controls["inviewCompanyId"].disable();
        }

        this.companiesService.getIdByCompanyName(this.selectedInviewCompany?.description ?? "")
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.sureSimCompanyId=data.result;

            if (this.sureSimCompanyId<=0) {
              this.registerCompany           =true;
              this.inviewUserIdData          =[];
              this.addInviewCompanyButtonText="Register";
              this.alertColourProgress       =AlertClassColour.Red;
              this.progressInformation       =`${this.selectedInviewCompany?.description} is not ${ApplicationNames.eSimPlatform} registered`;
              this.warningMessageMain        ="Company not registered";
              this.warningMessageSub         =`The selected company is not registered on the ${ApplicationNames.eSimPlatform} and must be registered before continuing`;
              
              this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);

            } else {
              this.companiesService.getById(this.sureSimCompanyId)
              .pipe(
                catchError((error) => {
                  return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
                })
              )
              .subscribe({
                next: data => {
                  this.sureSimCompany       =data;
                  this.inviewCompanySelected=true;
            
                  this.refreshInviewUserData();
                  this.refreshCostCentreLv2Data();
                },
                error: error => {
                  this.exceptionsService.handleException(new Error(error));
                }
              });
            }
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public addInviewCompany() {
    try {
      if (!this.registerCompany) {
        this.createNewCompany=true;
      }
      
      this.companyModalForm.openForm(0);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public inviewCompanyHasBeenSaved(inviewCompanyId: number | undefined) {
    try {
      if (inviewCompanyId != undefined && inviewCompanyId>0) {
        this.userForm.controls["inviewCompanyId"].setValue(inviewCompanyId);
        
        this.refreshInviewCompanyData();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Inview User

  private refreshInviewUserData() {
    try {
      this.inviewUserIdData=[];

      if (this.selectedInviewCompany?.id != undefined && <number>this.selectedInviewCompany?.id>0) {

        if (this.newUser) {
          this.inviewUsersService.getCompanyUsersCount(<number>this.selectedInviewCompany?.id, undefined)//, this.userForm.get('partialUserSearch')?.value)
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
          .subscribe({
            next: data => {
              if (data["result"]
                  >
                  this.configSystemService.getValueAsInteger(ConfigSystemParams.InviewUserListLimit, ConfigSystemParamDefaults.InviewUserListLimit)) {
                  
                this.searchForInviewUser=true;
                this.userForm.controls["inviewUserId"].disable();

                if (this.inputInviewUserId != undefined && (this.inputInviewUserId>0 || this.inputInviewUserId==modalFormValues.createNewUserId)) {
                  this.createAndSelectSearchedUser(this.inputInviewUserId);
                }
                // this.haveInviewUserData      =false;
                // this.partialUserSearchEnabled=true;
                // this.warningModalForm.openForm("Large Result Set", `The number of users of the selected company has a count of ${data["result"]}<br><br>Please refine your search by entering full or partial user details within the "Partial Search" field`);

              } else {
                this.userForm.controls["inviewUserId"].enable();
                this._refreshInviewUserData();
                // this.haveInviewUserData=data.result>0;
              }

             },
            error: error => {
              this.userFormCancelled.emit();
              this.exceptionsService.handleException(new Error(error));
            }
          });

        } else {
          this._refreshInviewUserData();
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private _refreshInviewUserData() {
    try {
      if ((this.userType==eUser.associate) && this.configSystemService.getValueAsBoolean(ConfigSystemParams.AddAssociateUserExcludeSureSimUsers)) {
        this.getDropdownData(this.inviewUsersService.getByCompanyId_ExcludeSureSimUsersIncAssociates(<number>this.selectedInviewCompany?.id ?? -1, undefined /*this.userForm.get('partialUserSearch')?.value*/), "inviewUserId");
      
      } else if (this.portalUser && this.configSystemService.getValueAsBoolean(ConfigSystemParams.AddPortalUserExcludeSureSimUsers)) {
        this.getDropdownData(this.inviewUsersService.getByCompanyId_ExcludeSureSimPortalUsers(<number>this.selectedInviewCompany?.id ?? -1, undefined /*this.userForm.get('partialUserSearch')?.value*/), "inviewUserId");
      
      } else if (!this.portalUser && this.configSystemService.getValueAsBoolean(ConfigSystemParams.AddEsimUserExcludeSureSimUsers)) {
        this.getDropdownData(this.inviewUsersService.getByCompanyId_ExcludeSureSimEsimUsers(<number>this.selectedInviewCompany?.id ?? -1, undefined /*this.userForm.get('partialUserSearch')?.value*/), "inviewUserId");

      } else {
        this.getDropdownData(this.inviewUsersService.getByCompanyId(<number>this.selectedInviewCompany?.id ?? -1), "inviewUserId");
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  // public partialInviewUserSearch() {
  //   try {
  //     let searchValue: string | undefined=this.userForm.get('partialUserSearch')?.value;

  //     if (searchValue==undefined || searchValue.trim()=="") {
  //       this.warningModalForm.openForm("Search Value Required", "Please enter a partial value to search on");

  //     } else {
  //       this.refreshInviewUserData();
  //     }
  //   }
  //   catch(e) {
  //     this.exceptionsService.handleException(<Error>e);
  //   }
  // }
  
  public inviewUserSelectDropDownChange(ev: any) {
    try {
      if (!this.newUser)
        return;
      
      this.createNewUserSelected =false;
      this.existingToBePortalUser=false;
      this.inviewUserCreated     =false;
      this.inviewUserSelected    =false;
      this.isIotDevice           =(this.associateUser || this.portalUser) ? false : undefined;

      if (this.inviewUserIdData==undefined)
        return;

      this.enableDisableControls(false);
      this.userForm.controls["countryId"].enable();
      this.userForm.controls["countryId"].setValue("");
      this.applyDefaultCountryId();
      this.userForm.controls["customerTag"].enable();
      this.userForm.controls["customerTag"].setValue("");
      this.userForm.controls["customerTag2"].enable();
      this.userForm.controls["customerTag2"].setValue("");
      //this.userForm.controls["email"].enable();
      //this.userForm.controls["email"].setValue("");
      this.userForm.controls["firstname"].enable();
      this.userForm.controls["firstname"].setValue("");
      this.userForm.controls["inviewCostCentreIdLv1"].enable();
      this.userForm.controls["inviewCostCentreIdLv1"].setValue("");
      this.userForm.controls["inviewCostCentreIdLv2"].enable();
      this.userForm.controls["inviewCostCentreIdLv2"].setValue("");
      this.userForm.controls["useCostCentres"].setValue(false);
      this.userForm.controls["userOrIotDevice"].setValue(undefined);
      this.userForm.controls["lastname"].enable();
      this.userForm.controls["lastname"].setValue("");
      this.userForm.controls["mobilenumber"].enable();
      this.userForm.controls["mobilenumber"].setValue("");
      this.userForm.controls["passwordEncTemp"].enable();
      this.userForm.controls["passwordEncTemp"].setValue("");
      this.userForm.controls["username"].enable();
      this.userForm.controls["username"].setValue("");
      //this.userForm.get("username")?.clearValidators();
      //this.userForm.get("username")?.updateValueAndValidity();
      
      this.selectedInviewCostCentreLv1=undefined;
      this.selectedInviewCostCentreLv2=undefined;
      this.costCentreLv2SelectDropDownChange(undefined);

      if (this.userForm.get('inviewUserId')?.value==modalFormValues.createNewUserId) {
        this.createNewUserSelected=true;
        this.alertColourProgress  =AlertClassColour.Green;
        this.progressInformation  =`New User to be created`;
        this.enableDisableControls(true);
        //this.userForm.get("username")?.addValidators([Validators.required, Validators.email]);
        
        this.setOrClearCostCentreValidators(this.costCentreDropdownsVisible());

      } else {
        this.selectedInviewUser=this.inviewUserIdData.find(x => x.userID==this.userForm.get('inviewUserId')?.value);
        let gotUser            =this.selectedInviewUser?.userID != undefined && <number>this.selectedInviewUser?.userID>0;      
  
        if (gotUser) {
          this.useInternationalDialCode=false;

          this.usersService.getIdByUsername(this.sureSimCompanyId ?? 0, this.selectedInviewUser?.email ?? "")
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
          .subscribe({
            next: data => {
              this.sureSimUserId=data.result;
              
              if (this.sureSimUserId!>0) {
                this.getSureSimUser();

              } else {
                this.alertColourProgress      =AlertClassColour.Grey;
                this.costCentreMissingInInview=false;
                this.inviewUserSelected       =true;
                this.progressInformation      =this.initialStatus;
                this.submitButtonEnabled      =true;

                if (this.newUser) {
                  this.existingToBePortalUser=this.portalUser;

                  this.getCostCentreParentId();

                  if (this.selectedInviewUser?.clIs != undefined && this.selectedInviewUser?.clIs.length>0 && this.selectedInviewUser?.clIs[0].trim() != "")
                    this.userForm.controls["mobilenumber"].disable();

                  this.userForm.controls["mobilenumber"].setValue(this.selectedInviewUser?.clIs[0]);

                  // if (this.selectedInviewUser?.email != undefined && this.selectedInviewUser?.email.trim() != "")
                  //   this.userForm.controls["email"].disable();

                  //this.userForm.controls["email"].setValue(this.selectedInviewUser?.email.includes("@") ? this.selectedInviewUser?.email : "");

                  if (this.selectedInviewUser?.firstName != undefined && this.selectedInviewUser?.firstName.trim() != "")
                    this.userForm.controls["firstname"].disable();

                  this.userForm.controls["firstname"].setValue(this.selectedInviewUser?.firstName);

                  if (<number>this.selectedInviewUser?.costCenterID>0)
                    this.userForm.controls["useCostCentres"].setValue(true);

                  this.userForm.controls["inviewCostCentreIdLv1"].disable();
                  this.userForm.controls["inviewCostCentreIdLv1"].setValue(this.selectedInviewUser?.costCenterID);

                  this.userForm.controls["inviewCostCentreIdLv2"].disable();
                    
                  if (this.selectedInviewUser?.surname != undefined && this.selectedInviewUser?.surname.trim() != "")
                    this.userForm.controls["lastname"].disable();

                  this.userForm.controls["lastname"].setValue(this.selectedInviewUser?.surname);
                    
                  if (this.selectedInviewUser?.email.includes("@"))
                    this.userForm.controls["username"].disable();
                  
                  this.userForm.controls["username"].setValue(this.selectedInviewUser?.email.includes("@") ? this.selectedInviewUser?.email : "");
                }
                
                this.enableDisableControls(true);
              }
            },
            error: error => {
              this.exceptionsService.handleException(new Error(error));
            }
          });
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public createInviewUser() {
    try {
      let sureSimUsername    =this.userForm.get("username")?.value;
      this.selectedInviewUser=this.inviewUserIdData.find(x => x.email==sureSimUsername);

      if (this.selectedInviewUser != undefined) {
        this.alertColourProgress=AlertClassColour.Green;
        this.progressInformation=`${sureSimUsername} already exists on Inview`;

        this.prepareToSaveUser();

      } else {
        if (this.inviewAutoCreateCostCentres && (this.sureSimCompany?.pureSSCompany || !this.costCentreDropdownsVisible())) {
          this.autoCreateCostCentres();

        } else {
          this._createInviewUser(<number>this.selectedInviewCostCentreLv1?.id ?? -1);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public _createInviewUser(inviewCostCentreLv1: number) {
    try {
      let sureSimUsername=this.userForm.get("username")?.value;
      let clis           =[];

      if (this.userForm.get('mobilenumber')?.value != undefined && this.userForm.get('mobilenumber')?.value.trim() != "") {
        clis.push(this.userForm.get('mobilenumber')?.value);
      }

      var inviewUser: InviewUserDTO;
      inviewUser = {
        clIs                  : clis,
        companyId             : <number>this.selectedInviewCompany?.id ?? -1,
        costCenterID          : inviewCostCentreLv1,
        createdById           : this.curUser.inviewUserId,
        email                 : this.userForm.get('username')?.value, //This is correct as SureSIM uses Username to login and Inview uses email
        existingToBePortalUser: false,
        firstName             : this.userForm.get('firstname')?.value,
        mobileE164            : this.userForm.get('mobilenumberE164')?.value,
        portalUser            : this.portalUser,
        surname               : this.userForm.get('lastname')?.value,
        userID                : 0,
        username              : this.userForm.get('firstname')?.value + " " + this.userForm.get('lastname')?.value,
        hasSureSIMAccess      : this.userForm.controls["hasSureSIMAccess"].value
      };

      this.postNewInviewUser(inviewUser)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          //CRN_20260317 - Inview user created, so no duplicate Inview create attempt
          this.inviewUserCreated=true;
          this.userFormSubmitted=false;

          this.selectedInviewUser={
            clIs                  : data.clIs,
            companyId             : data.companyId,
            costCenterID          : data.costCenterID,
            email                 : data.email,
            existingToBePortalUser: false,
            firstName             : data.firstName,
            passwordEncrypted     : data.passwordEncrypted,
            passwordTempExpiry    : data.passwordTempExpiry,
            portalUser            : data.portalUser,
            surname               : data.surname,
            userID                : data.userID,
            username              : data.username
          }

          this.alertColourProgress=AlertClassColour.Green;
          this.progressInformation=`${sureSimUsername} submitted to Inview`;

          this.refreshInviewUserData();
          this.prepareToSaveUser();
        },
        error: error => {
          this.submitButtonEnabled=true;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.submitButtonEnabled=true;
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public updateInviewUser() {
    try {
      let cliUpdates: CliUpdatesDTO[]=[];

      if (!this.newUser && this.originalMobileNo != undefined && this.originalMobileNo != this.sureSimUser!.mobile) {
        let cliUpdate: CliUpdatesDTO={
          newCLI: this.sureSimUser!.mobile,
          oldCLI: this.originalMobileNo
        }
        
        cliUpdates.push(cliUpdate);
      }

      var inviewUser          : InviewUserDTO={
        clIs                  : [],
        cliUpdates            : cliUpdates,
        companyId             : 0,
        costCenterID          : 0,
        createdById           : this.curUser.inviewUserId,
        email                 : this.sureSimUser!.username, //This is correct as SureSIM uses Username to login and Inview uses email
        existingToBePortalUser: this.existingToBePortalUser,
        firstName             : this.sureSimUser!.firstname,
        portalUser            : false,
        surname               : this.sureSimUser!.lastname,
        userID                : this.sureSimUser!.inviewUserID,
        username              : this.sureSimUser!.firstname + " " + this.sureSimUser!.lastname,
      };

      this.putInviewUser(inviewUser)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.processComplete();
        },
        error: error => {
          this.submitButtonEnabled=true;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.submitButtonEnabled=true;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private postNewInviewUser(inviewUser: InviewUserDTO): Observable<InviewUserDTO> {
    return this.inviewUsersService.post(inviewUser);
  }

  private putInviewUser(inviewUser: InviewUserDTO): Observable<InviewUserDTO> {
    return this.inviewUsersService.put(inviewUser);
  }
  
  public emailkeyup(ev: any) {
    try {
      // if (this.inviewUserSelected) {
      //   this.userForm.controls["username"].setValue(this.userForm.controls["email"].value);
      // }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Inview User Search
  
  public _searchForInviewUser() {
    try {
      this.userSearchForm.openForm(<number>this.selectedInviewCompany?.id, <string>this.selectedInviewCompany?.description);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public searchFormCancelled() {
    try {
      this.inviewUserIdData=[];

      this.userForm.controls["inviewUserId"].setValue(undefined);
      this.inviewUserSelectDropDownChange(undefined);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public searchGridRowClick(rowId: number) {
    try {
      this.createAndSelectSearchedUser(rowId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private createAndSelectSearchedUser(rowId: number) {
    try {
      this.inviewUsersService.getByUserId(rowId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          let selectedId       =undefined;
          this.inviewUserIdData=[];

          if (data==null || data==undefined) {
            selectedId=modalFormValues.createNewUserId;

            this.inviewUserIdData.push({
              clIs                  : [],
              companyId             : 0,
              costCenterID          : 0,
              email                 : modalFormValues.createNewUser,
              existingToBePortalUser: false,
              firstName             : "",
              portalUser            : this.portalUser,
              surname               : "",
              userID                : modalFormValues.createNewUserId,
              username              : ""
            });

          } else {
            selectedId=data.userID;

            if (data.cli != undefined) {
              data.clIs=[];
              data.clIs.push(data.cli);
            }
                    
            this.inviewUserIdData.push(data);
          }

          this.userForm.controls["inviewUserId"].setValue(selectedId);
          this.inviewUserSelectDropDownChange(undefined);
         },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#endregion

  //#region Inview CostCentre

  get formOfCostCentreAdd() {
    return this.costCentreAddForm.controls;
  }

  public refreshCostCentreLv2Data() {
    try {
      this.inviewCostCentreIdLv2Data=[];

      if (this.selectedInviewCompany?.id != undefined && <number>this.selectedInviewCompany?.id>0) {
        this.getDropdownData(this.inviewCostCentresService.getIdAndDescription_Lv2(<number>this.selectedInviewCompany!.id ?? -1), "inviewCostCentreIdLv2");
      }

      this.refreshCostCentreLv1Data();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public costCentreLv2SelectDropDownChange(ev: any) {
    try {
      if (!this.newUser)
        return;
      
      this.selectedInviewCostCentreLv2=this.inviewCostCentreIdLv2Data.find(x => x.id==this.userForm.get('inviewCostCentreIdLv2')?.value);
      this.costCentreLv1ButtonEnabled =this.selectedInviewCostCentreLv2?.id!=undefined && <number>this.selectedInviewCostCentreLv2?.id>0;

      if (this.selectedInviewCostCentreLv2?.description==undefined || this.selectedInviewCostCentreLv2?.description.trim()=="") {
        this.costCentreMissingInInview=true;

        this.userForm.controls["inviewCostCentreIdLv1"].enable();
        this.userForm.controls["inviewCostCentreIdLv2"].enable();
      }

      this.refreshCostCentreLv1Data();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public refreshCostCentreLv1Data() {
    try {
      this.inviewCostCentreIdLv1Data=[];

      if (this.selectedInviewCompany?.id!=undefined &&
        <number>this.selectedInviewCompany?.id>0  &&
        this.selectedInviewCostCentreLv2?.id!=undefined &&
        <number>this.selectedInviewCostCentreLv2?.id>0
       ) {
        this.getDropdownData(this.inviewCostCentresService.getIdAndDescription_Lv1(<number>this.selectedInviewCompany!.id ?? -1, <number>this.selectedInviewCostCentreLv2!.id ?? -1), "inviewCostCentreIdLv1");
       }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public costCentreLv1SelectDropDownChange(ev: any) {
    try {
      if (!this.newUser)
        return;
      
      this.selectedInviewCostCentreLv1=this.inviewCostCentreIdLv1Data.find(x => x.id==this.userForm.get('inviewCostCentreIdLv1')?.value);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public addNewCostCentre(level: number, addNewCostCentreContent: any) {
    try {
      this.costCentreAddForm.reset();
      this.costCentreAddFormSubmitted=false;
      this.costCentreLevel           =level;
      this.costCentreModalRef        =this.modalService.open(addNewCostCentreContent, { backdrop: this.modalBackGround,
                                                                                        centered: true,
                                                                                        keyboard: false,
                                                                                        size    : msSize.Medium });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public getCostCentreParentId() {
    try {
      this.inviewCostCentresService.getCostCentreParentId(<number>this.selectedInviewCompany?.id, <number>this.selectedInviewUser?.costCenterID)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.userForm.controls["inviewCostCentreIdLv2"].setValue(data["result"]);

          this.costCentreLv2SelectDropDownChange(undefined);
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public costCentreAddFormSubmit() {
    try {
      this.costCentreAddFormSubmitted = true;

      if (this.costCentreAddForm.valid)
      {
        var inviewCostCentre: InviewCostCentreDTO;
        inviewCostCentre={
          companyId      : <number>this.selectedInviewCompany?.id ?? -1,
          costCenter2Name: this.costCentreLevel==1 ? this.selectedInviewCostCentreLv2?.description : undefined,
          costCenterId   : 0,
          costCenterName : this.costCentreAddForm.get('costCentreName')?.value,
          createdById    : this.curUser.inviewUserId,
          level          : this.costCentreLevel,
          parentId       : this.costCentreLevel==1 ? <number>this.selectedInviewCostCentreLv2?.id : undefined,
        };
        
        this.postNewInviewCostCentre(inviewCostCentre)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.costCentreModalRef.close();
            this.costCentreAddForm.reset();
            this.costCentreAddFormSubmitted = false;

            if (this.costCentreLevel==1) {
              this.userForm.controls["inviewCostCentreIdLv1"].setValue(data.costCenterId);
              
              this.selectedInviewCostCentreLv1={
                id         : data.costCenterId,
                description: data.costCenterName
              }

              this.refreshCostCentreLv1Data();
            } else {
              this.userForm.controls["inviewCostCentreIdLv2"].setValue(data.costCenterId);
              
              this.selectedInviewCostCentreLv2={
                id         : data.costCenterId,
                description: data.costCenterName
              }
              
              this.refreshCostCentreLv2Data();
              
              this.costCentreLv1ButtonEnabled=true;
            }
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public autoCreateCostCentres() {
    try {
      //Auto Created Cost Centres are in the form of "Level 1 Unallocated" or "Level 2 SureSIM"
      
      let costCentreLv1Name: string=CostCentreAutoLevels.Level1;
      let costCentreLv2Name: string=CostCentreAutoLevels.Level2;

      this.inviewCostCentresService.getCostCentreByName(<number>this.selectedInviewCompany?.id, costCentreLv2Name, 2)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: costCentreLv2 => {
          const costCentreLv2Id: number=<number>costCentreLv2?.costCenterId ?? 0;

          if (costCentreLv2Id<=0) {
            this.autoCreateCostCentre(costCentreLv2Name, 2, undefined);
            return;
          }

          this.inviewCostCentreIdLv2Auto=costCentreLv2Id;

          this.inviewCostCentresService.getCostCentreByName(<number>this.selectedInviewCompany?.id, costCentreLv1Name, 1)
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
          .subscribe({
            next: data => {
              if (data?.costCenterId==null || data?.costCenterId==undefined || data.costCenterId<=0) {
                this.autoCreateCostCentre(costCentreLv1Name, 1, costCentreLv2Id, costCentreLv2Name);
              } else {
                this.inviewCostCentreIdLv1Auto=<number>data.costCenterId;

                this._createInviewUser(data.costCenterId);
              }
            },
            error: error => {
              this.submitButtonEnabled=true;
              this.exceptionsService.handleException(new Error(error));
            }
          });
        },
        error: error => {
          this.submitButtonEnabled=true;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.submitButtonEnabled=true;
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public autoCreateCostCentre(costCentreName: string, costCentreLevel: 1 | 2, parentId: number | undefined, costCentre2Name: string | undefined = undefined) {
    try {
      var inviewCostCentre: InviewCostCentreDTO={
        companyId      : <number>this.selectedInviewCompany?.id ?? -1,
        costCenter2Name: costCentreLevel==1 ? costCentre2Name : undefined,
        costCenterId   : 0,
        costCenterName : costCentreName,
        createdById    : this.curUser.inviewUserId,
        level          : costCentreLevel,
        parentId       : parentId,
      };
      
      this.postNewInviewCostCentre(inviewCostCentre)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          if (costCentreLevel==2) {
            this.inviewCostCentreIdLv2Auto=data.costCenterId;

            this.autoCreateCostCentre(costCentreName.replace(CostCentreAutoLevels.Level2, CostCentreAutoLevels.Level1), 1, data.costCenterId, costCentreName);

          } else {
            this.inviewCostCentreIdLv1Auto=data.costCenterId;

            this._createInviewUser(data.costCenterId);
          }
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private postNewInviewCostCentre(inviewCostCentre: InviewCostCentreDTO): Observable<InviewCostCentreDTO> {
    return this.inviewCostCentresService.post(inviewCostCentre);
  }

  //#endregion

  //#region Navigation

  public onTabChange(event: NgbNavChangeEvent) {
    try {
      if (event.nextId == this.navItemSupport) {
        this.userModalFormRef.update({ size : msSize.ExtraLarge }); 
      } else {
        this.userModalFormRef.update({ size : msSize.Large });        
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region SureSIM User

  private applyCompanyCeasedState(): void {
    try {
      if (this.sureSimUser?.companyCeased!==true)
        return;

      this.fileLockHoverText="This user's company has been ceased";
      this.formIsLocked     =true;
      this.formTitle        =this.formTitle + " (Ceased)";

      this.lockDownForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public getSureSimUser() {
    try {
      this.usersService.getById(<number>this.sureSimUserId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.sureSimUser             =data;
          this.originalMobileNo        =this.sureSimUser.mobile;
          this.useInternationalDialCode=!this.isIotDevice &&
                                        this.useInternationalDialCode &&
                                        this.sureSimUser.mobileIntCode != null &&
                                        this.sureSimUser.mobileIntCode != undefined &&
                                        this.sureSimUser.mobileIntCode.trim() != "";

          this.populateFormFields(this.userForm);
          this.applyDefaultCountryIdLoadCompanyIfNeeded();

          if (!this.newUser) {
            this.userIsLocked();
            this.applyCompanyCeasedState();
            this.openModal();
            this.startWatchingForEdits();

          } else if ((this.userType==eUser.associate) && !this.sureSimUser!["portalUser"] && !this.sureSimUser!["eSimUser"]) {
            this.alertColourProgress=AlertClassColour.Green;
            this.progressInformation=`"${this.selectedInviewUser?.email}" is already registered as an Associate`;

          } else if (this.portalUser && this.sureSimUser!["portalUser"]) {
            this.alertColourProgress=AlertClassColour.Green;
            this.progressInformation=`"${this.selectedInviewUser?.email}" is already registered as a Portal User`;

          } else if (!this.portalUser && this.sureSimUser!["eSimUser"]) {
            this.alertColourProgress=AlertClassColour.Green;
            this.progressInformation=`"${this.selectedInviewUser?.email}" is already ${ApplicationNames.eSimPlatform} an eSIM User`;

          } else {
            this.existingToBePortalUser   =this.portalUser;
            this.userToBePortalAndEsimUser=true;
            this.alertColourProgress      =AlertClassColour.Grey;
            this.inviewUserSelected       =true;
            this.progressInformation      =this.initialStatus;
            this.submitButtonEnabled      =true;
            this.costCentreMissingInInview=false;

            if (<number>this.selectedInviewUser?.costCenterID>0)
              this.userForm.controls["useCostCentres"].setValue(true);

            this.userForm.controls["inviewCostCentreIdLv1"].disable();
            this.userForm.controls["inviewCostCentreIdLv2"].disable();

            if (this.portalUser) {
              this.userForm.controls["accessTypeId"].setValue(undefined);
              this.applyDefaultAccessTypeId();
            }

            this.costCentreLv2SelectDropDownChange(undefined);
          }
        },
        error: error => {
          this.userFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private startWatchingForEdits(): void {
    try {
      if (!this.userForm)
        return;
  
      if (this.formChangesSubscription) {
        this.formChangesSubscription.unsubscribe();
        this.formChangesSubscription=undefined;
      }
  
      setTimeout(() => {
        this.formChangesSubscription=this.userForm.valueChanges
          .pipe(debounceTime(50))
          .subscribe(_ => {
            if (!this.newUser && this.submitEnableOnEdit) {
              this.enableDisableControls(this.userForm.dirty);
            }
          });
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public userIsLocked() {
    try {
      this.authenticationService.userIsLocked(this.sureSimUser!.username)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.inviewAccountLocked=data.result;
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public padLockClick() {
    try {
      let lockAccount: boolean;
      let service    : Observable<any>;

      if (this.inviewAccountLocked) {
        lockAccount=false;
        service    =this.authenticationService.unlockUser(this.sureSimUser!.username);
      }
      else {
        lockAccount=true;
        service    =this.authenticationService.lockUser(this.sureSimUser!.username, <number>this.sureSimUser!.inviewCompanyID);
      }

      service
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.inviewAccountLocked=lockAccount ? data.result : !data.result;
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private prepareToSaveUser() {
    try {
      let sureSimUsername=this.userForm.get("username")?.value;

      let accessTypeId=this.userForm.controls["accessTypeId"].value;
          accessTypeId=accessTypeId != undefined && accessTypeId != '' ? accessTypeId : -1;
      let eSimUser    =(( this.portalUser && this.sureSimUser?.eSimUser   != undefined) ? this.sureSimUser?.eSimUser   : !this.portalUser) && (this.userType!=eUser.associate);
      let portalUser  = (!this.portalUser && this.sureSimUser?.portalUser != undefined) ? this.sureSimUser?.portalUser :  this.portalUser;
      
      this.sureSimUser={
        accessTypeID       : accessTypeId,
        active             : this.userForm.controls["active"].value,
        companyID          : (this.newUser ? this.sureSimCompanyId : this.sureSimUser?.companyID) ?? -1,
        countryID          : this.userForm.controls["countryId"].value,
        email              : sureSimUsername,
        enteredBy          : this.curUser.userId,
        eSimUser           : eSimUser,
        firstname          : this.userForm.controls["firstname"].value,
        fullname           : this.userForm.controls["firstname"].value+" "+this.userForm.controls["lastname"].value,
        guid               : this.sureSimUser?.guid==undefined ? Guid.create() : this.sureSimUser?.guid,
        id                 : this.sureSimUserId ?? -1,
        inviewCostCentreID : this.inviewCostCentreIdLv1Auto>0 ? this.inviewCostCentreIdLv1Auto :
                             (this.newUser && !this.userToBePortalAndEsimUser ? <number>this.selectedInviewCostCentreLv1?.id : this.sureSimUser?.inviewCostCentreID) ?? -1,
        inviewCostCentreID2: this.inviewCostCentreIdLv2Auto>0 ? this.inviewCostCentreIdLv2Auto :
                             (this.newUser && !this.userToBePortalAndEsimUser ? <number>this.selectedInviewCostCentreLv2?.id : this.sureSimUser?.inviewCostCentreID2) ?? -1,
        inviewUserID       : (this.newUser && !this.userToBePortalAndEsimUser ? <number>this.selectedInviewUser?.userID : this.sureSimUser?.inviewUserID) ?? -1,
        iotDevice          : this.isIotDevice ? true : false,
        lastname           : this.userForm.controls["lastname"].value,
        mobile             : <string>this.userForm.controls["mobilenumber"].value,
        mobileE164         : <string>this.userForm.controls["mobilenumberE164"].value,
        mobileIntCode      : this.userForm.controls["mobilenumberIntCode"].value,
        occupationTypeID   : this.userForm.controls["occupationTypeId"].value,
        portalUser         : portalUser,
        sendBill           : this.userForm.controls["sendBill"].value,
        tag                : this.userForm.controls["customerTag"].value,
        tag2               : this.userForm.controls["customerTag2"].value,
        username           : sureSimUsername,
        hasSureSIMAccess   : this.userForm.controls["hasSureSIMAccess"].value
      };

      if (this.newUser && this.selectedInviewUser?.passwordEncrypted != undefined && this.selectedInviewUser?.passwordEncrypted.trim() != "") {
        this.sureSimUser.changePasswordOnLogin=true;
        this.sureSimUser.passwordEncTemp      =this.selectedInviewUser?.passwordEncrypted;
        this.sureSimUser.passwordTempExpiry   =this.selectedInviewUser?.passwordTempExpiry;
      }

      this.saveUser(this.sureSimUser)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.alertColourProgress=AlertClassColour.Green;

          if (this.newUser) {
            this.progressInformation=`${sureSimUsername} has been registered on the ${ApplicationNames.eSimPlatform}`;
          } else {
            this.progressInformation=`${sureSimUsername} details have been updated on the ${ApplicationNames.eSimPlatform}`;
          }
          
          this.updateInviewUser();

          if (this.newUser != this.userToBePortalAndEsimUser) {
            this.sureSimUser!.id=data["id"];
            this.sureSimUserId  =data["id"];
          }

          this.inviewUserDataHasBeenSaved.emit(<number>this.selectedInviewUser?.userID);
          this.sureSimUserDataHasBeenSaved.emit(this.sureSimUserId);
        },
        error: error => {
          this.submitButtonEnabled=true;
          this.alertColourProgress=AlertClassColour.Red;
          this.progressInformation=`Process cannot continue - ${error.message}`;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.submitButtonEnabled=true;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private saveUser(user: UserDTO): Observable<UserDTO> {
    return this.usersService.save(user);
  }

  //#endregion

  //#region Process Complete

  private processComplete() {
    try {
      this.completedModalForm.openForm(this.newUser ? "User Created" : "User Details Updated", "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public completedModalHasBeenClosed() {
    try {
      if (this.closeFormOnCompleted) {
        this.userModalFormRef.close();
        this.sureSimUserDataHasBeenSaved.emit(undefined);
      }
      this.closeFormOnCompleted=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  public activeClick() {
    try {
      if (!this.newUser && this.portalUser && this.sureSimUser!.id==this.curUser.userId) {
        this.warningModalForm.openForm("Cannot Action", "You cannot change the 'Active' value of your own user. Please contact your line manager to action.");
        this.userForm.controls["active"].setValue(true);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Reset 2FA

  public btn2FaVisible(): boolean {
    try {
      return this.sureSimUser != undefined
             && (!this.sureSimUser.companyHasSso
                 || this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserReset2FaButtonShowIfSso, false))
             && this.portalUser
             && !this. newUser
             && (this.componentAccessUserService.hasAccessGuid(AccessGuids.FormUserReset2FaButton)
                 || this.curUser.systemAdmin
                 || this.curUser.systemAdminStd);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public reset2Fa() {
    try {
      this.reset2FaConfirmModal.openForm("WARNING - 2FA Reset",
                                          "Are you sure you want to reset the user's 2FA?",
                                          undefined,
                                          OurColors.Red,
                                          OurColors.DarkBlue);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public yesReset2Fa() {
    try {
      this.totpService.reset2Fa(<number>this.sureSimUser?.companyID, <Guid>this.sureSimUser?.guid)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          if (data.result) {
            this.completedModalForm.openForm("Success", "2FA has been reset");

          } else {
            this.warningModalForm.openForm("Warning", "2FA could not be reset");
          }
        },
        error: error => {
          this.userFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }})
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Reset Password

  public btnPasswordVisible(): boolean {
    try {
      return this.sureSimUser != undefined
             && (!this.sureSimUser.companyHasSso
                 || this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserResetPasswordButtonShowIfSso, false))
             && this.portalUser
             && !this. newUser
             && (this.componentAccessUserService.hasAccessGuid(AccessGuids.FormUserResetPasswordButton)
                 || this.curUser.systemAdmin
                 || this.curUser.systemAdminStd);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public resetPassword() {
    try {
      this.resetPasswordConfirmModal.openForm("WARNING - Password Reset",
                                              "Are you sure you want to reset the user's password?<br><br>The user will be sent password reset instructions by email.",
                                              undefined,
                                              OurColors.Red,
                                              OurColors.DarkBlue);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public yesResetPassword() {
    try {
      this.authenticationService.resetPassword(<string>this.sureSimUser?.username)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.completedModalForm.openForm("Success", `The request has been sent to ${this.sureSimUser?.username}`);
        },
        error: error => {
          this.userFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }})
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Messaging
  
  public messageClick() {
    try {
      if (!this.communicationModalFormIsOpen) {
        this.communicationModalFormIsOpen=true;

        this.showComposeForm=true;
        this.changeDetectorRef.detectChanges();
        this.communicationComposeModalForm.openForm(this.sureSimUser?.companyID, this.sureSimUser?.id);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public communicationDataHasBeenSaved(communicationId: number | undefined) {
    try {
      this.communicationModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public communicationFormHasBeenCancelled() {
    try {
      this.communicationModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region System Lock
  
  private processSystemLock(): void {
    try {
      if (!this.systemLocksEnabled)
        return;

      const systemLock: SystemLockDTO={
        active    : true,
        enteredBy : this.curUser.userId,
        entityID  : this.sureSimUserId ?? -1,
        entityLock: SystemLocks.User,
        id        : -1
      };
    
      this.systemLockService.entityIsLocked(systemLock)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          const possibleSystemLock: SystemLockDTO=data;

          if (possibleSystemLock.locked) {

            if (possibleSystemLock.sameUserLock) {
              this.systemLockId=possibleSystemLock.id;
            }
            else {
              this.formIsLocked=true;
              const lockDetail =`User is being edited by\n\n${possibleSystemLock.enteredByName}\n\nas of ${this.datePipe.transform(possibleSystemLock.enteredDate, 'dd/MM/yyyy HH:mm:ss')}`;

              if (this.systemLocksShowDetails)
                this.fileLockHoverText=lockDetail;

              if (this.systemLocksShowWarningModal) {
                this.warningModalForm.openForm("WARNING",
                                               (<string>this.fileLockHoverText).replaceAll("\n", "<br>") + "<br><br>Changes are not permitted until the Edit is complete",
                                               "https://cdn.lordicon.com/fikcyfpp.json");
              }

              this.lockDownForm();
            }

          } else {
            this.lockEntity(systemLock);
          }
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private lockEntity(systemLock: SystemLockDTO): void {
    try {
      this.systemLockService.lockEntity(systemLock)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.systemLockId=data.id;
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private unlockEntity(): void {
    try {
      if (!this.systemLocksEnabled || !this.systemLockId || this.systemLockId<0)
        return;

      this.systemLockService.unlockEntity(this.systemLockId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private lockDownForm(): void {
    try {
      this.userForm.get("accessTypeId")?.disable();
      this.userForm.get("active")?.disable();
      this.userForm.get("countryId")?.disable();
      this.userForm.get("customerTag")?.disable();
      this.userForm.get("customerTag2")?.disable();
      this.userForm.get("firstname")?.disable();
      this.userForm.get("lastname")?.disable();
      this.userForm.get("mobilenumber")?.disable();
      this.userForm.get("occupationTypeId")?.disable();
      this.userForm.get("sendBill")?.disable();
      this.userForm.get("username")?.disable();
      this.userForm.get("userOrIotDevice")?.disable();

      this.dialCodeDropdown?.lockDownForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region UserGroups

  public addGroup() {
    this.userGroupModalForm.openFormUser(this.sureSimUserId ?? -1, this.sureSimUser?.companyID ?? -1);
  }

  private deleteAllocation(allocationId : number) {
    this.userGroupService.deleteUserAllocation(allocationId)
    .pipe(
      catchError((error) => {
        return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
      })
    )
    .subscribe({
      next: data => {
          this.userGroups.refreshGrid();
          this.closeFormOnCompleted=false;
          this.completedModalForm.openForm("INFORMATION", `User removed from group.`);
      },
      error: error => {
        this.exceptionsService.handleException(new Error(error));
      }
    });
  }

  public deleteButtonClick(allocationId : number) {
    try {
      this.allocationID = allocationId;
      this.userGroupConfirmModal.openForm("WARNING - Remove user from group",
                                          "Are you sure you want to remove this user from this group?.",
                                          undefined,
                                          OurColors.Red,
                                          OurColors.DarkBlue);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshGroups() {
    this.userGroups.refreshGrid();
  }

  public yesRemoveAllocation() {
    this.deleteAllocation(this.allocationID);
  }

  //#endregion
}
